const submissionTransactionType = {
    NEW_BUSINESS : 0,

    RENEWAL : 1

};

angular.module('gw-um-j2js')
    .constant('submissionTransactionType', submissionTransactionType);